import { MIME_TYPES } from "web_myplann/Infrastructure/Utils/mimeTypes";

export const svgMarkupToDataUri = (svgMarkup: string): string =>
	`data:${MIME_TYPES.svg};utf8,${encodeURIComponent(svgMarkup)}`;
